import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getStudyPlan } from './api';

/** The Study plan tab's data. Any signed-in learner may open it; without a goal it is null. */
export function useStudyPlan() {
  const { state } = useAuthContext();
  const userId = state.user?.id;
  return useQuery({
    queryKey: ['study-plan', 'plan', userId],
    queryFn: ({ signal }) => getStudyPlan(signal),
    enabled: Boolean(userId),
    refetchOnWindowFocus: true,
  });
}
